export default {
    state: () => ({
        formArray: [],
    }),
    mutations: {
        setFormResult(state, data) {
            state.formArray = []
            state.formArray = data
        },
    },
    actions: {
        getForm({commit}, code) {
            // let formData = new FormData();
            // formData.append('id', id);
            let formData = new FormData;
            formData.set('CODE', code);

            fetch('/api/webform/get/', {
                method: 'POST',
                body: formData,
            })
                .then(response => response.json())
                .then(result => {
                    if ('data' in result) {
                        commit('setFormResult', result.data)
                    }
                })
        }
    },
}